export function objectToQueryString(obj: any) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export function format(str: string, args: any[]) {
  let formatted = str;
  for (let arg in args) {
    formatted = formatted.split('{' + arg + '}').join(args[arg]);
  }
  return formatted;
}

export function isNumeric(str: any) {
  if (typeof str != "string") return false; // we only process strings!  
  return !isNaN(+str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
}